module.exports = __webpack_public_path__ + "img/2.401d2713.png";